import { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import PopupDialog from "../../components/elements/PopupDialog/PopupDialog";
import "./NoCatalogue.scss";

const NoCatalogue = (): ReactElement => {
	const { t } = useTranslation();

	return (
		<PopupDialog
			open={true}
			content={<div className="Message">{t("Error.qr_ordering_not_available")}</div>}
			data-testid="NoCataloguePopup"
			className="NoCatalogue"
		/>
	);
};

export default NoCatalogue;
